import { createContext } from "react";

import { TDateRangeFilterStore } from "./DateRangeFilter.types";

export const DateRangeFilterContext = createContext<TDateRangeFilterStore | null>(null);
